<app-header class="no-view"></app-header>
<app-sidebar  class="no-view"></app-sidebar>
<app-right-sidebar  class="no-view"></app-right-sidebar>
<router-outlet></router-outlet>
